import { FormGridRoot } from "./FormGrid.styles";
import FormGridRow from "./FormGridRow/FormGridRow";
import { Divider } from "@commonlibs";
import { FormGridProps } from "./FormGrid.types";
import clsx from "clsx";

function FormGrid({ className, rows, editable = false, style }: FormGridProps) {
    return (
        <FormGridRoot className={clsx("form-grid", className)} style={style}>
            {rows.map((row, index) => (
                <div style={{ display: editable && row.viewOnly ? "none" : "block" }} key={`${index}-${row.label}`}> {/* skipcq: JS-0437 */}
                    {/** // skipcq: JS-0437 */}
                    <FormGridRow {...row} editable={editable} />
                    {index !== rows.length - 1 && <Divider />}
                </div>
            ))}
        </FormGridRoot>
    );
}

export default FormGrid;
